import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent {
  @Input() customQuestionValue: boolean = false;
  @Input() progressionData = [];
  @Input() total: number = 0;
  @Input() current: number = 0;
  @Input() customClassContainer: string = '';
  @Input() customClassBar: string = '';

  getProgressionBar() {
    if (this.customQuestionValue) {
      let valueProgression = this.progressionData
        .slice(0, this.current)
        .reduce((acc, curr) => acc + curr, 0);
      let totalProgression = this.progressionData.reduce(
        (acc, curr) => acc + curr,
        0
      );
      return (valueProgression / totalProgression) * 100;
    } else {
      return (this.current / this.total) * 100;
    }
  }
}
